import { Trash2 } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function TrashIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Trash2
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
